<template>
<div>
<h4 class="text-primary mb-2">{{sectionname}}</h4>
<hr>

<CustomInputfield  v-for="item in section.inputfields" :data="item"></CustomInputfield>

<div class="ml-2">
<ListviewQuestionlistSection v-for="section in section.child_sections" :section="section"></ListviewQuestionlistSection>
</div>
</div>
</template>

<script>
 
export default {

  name: 'ListviewQuestionlistSection',
  props:["section"],
  computed:{
    sectionname()
    {
      return this.getTheTranslation(this.section,"translation")
    }
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
</style>